import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InventoryAuditTableQueryVariables = Types.Exact<{
  input: Types.InventoryHistoryInput;
  options?: Types.InputMaybe<Types.InventoryHistoryOptions>;
}>;


export type InventoryAuditTableQuery = { readonly __typename?: 'Query', readonly inventoryHistory: { readonly __typename?: 'InventoryHistoryPaged', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'InventoryHistory', readonly timestamp: string, readonly eventType: string, readonly skuName?: string | null, readonly location?: { readonly __typename?: 'Location', readonly name: string } | null, readonly user: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } }> } };


export const InventoryAuditTableDocument = gql`
    query inventoryAuditTable($input: InventoryHistoryInput!, $options: InventoryHistoryOptions) {
  inventoryHistory(input: $input, options: $options) {
    totalCount
    items {
      timestamp
      eventType
      location {
        name
      }
      skuName
      user {
        person {
          firstname
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useInventoryAuditTableQuery__
 *
 * To run a query within a React component, call `useInventoryAuditTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryAuditTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryAuditTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useInventoryAuditTableQuery(baseOptions: Apollo.QueryHookOptions<InventoryAuditTableQuery, InventoryAuditTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryAuditTableQuery, InventoryAuditTableQueryVariables>(InventoryAuditTableDocument, options);
      }
export function useInventoryAuditTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryAuditTableQuery, InventoryAuditTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryAuditTableQuery, InventoryAuditTableQueryVariables>(InventoryAuditTableDocument, options);
        }
export type InventoryAuditTableQueryHookResult = ReturnType<typeof useInventoryAuditTableQuery>;
export type InventoryAuditTableLazyQueryHookResult = ReturnType<typeof useInventoryAuditTableLazyQuery>;
export type InventoryAuditTableQueryResult = Apollo.QueryResult<InventoryAuditTableQuery, InventoryAuditTableQueryVariables>;